import messages from './messages.js';

const schema = {
  id: 'addEmployee',
  properties: [
    {
      id: 'firstName',
      type: 'text',
      label: messages.firstName,
      required: true,
    },
    {
      id: 'middleName',
      type: 'text',
      label: messages.middleName,
      attributes: { className: 'w-50' },
      required: false,
    },
    {
      id: 'lastName',
      type: 'text',
      label: messages.lastName,
      required: true,
    },
  ],
};

export default schema;
